import Vue from 'vue';
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import Captcha from './captcha.vue';
import Icon from './icon/index.vue';
import sweetGtCaptcha from 'sweet-gt-captcha';

Vue.component(VueCountdown.name, VueCountdown);
Vue.component(VueQrcode.name, VueQrcode);
Vue.component(Captcha.name, Captcha);
Vue.component(Icon.name, Icon);
Vue.component(sweetGtCaptcha.name, sweetGtCaptcha);
